import DangerButton from 'lib/ui/Button/DangerButton'
import ConfirmDialog from 'lib/ui/ConfirmDialog'
import {ErrorText} from 'lib/ui/TextField/HelperText'
import {OBIE, useServices} from 'organization/Event/Services/ServicesProvider'
import React, {useState} from 'react'

export default function DisconnectButton() {
  const {unlink, remove} = useServices()
  const [error, setError] = useState<string | null>(null)

  const handleConfirm = () => {
    setError(null)

    unlink(OBIE)
      .then(() => remove(OBIE))
      .catch((e) => setError(e.message))
  }

  return (
    <ConfirmDialog
      onConfirm={handleConfirm}
      title="Disconnect Obie?"
      confirmLabel="Disconnect"
      description="Disconnecting Obie stops the attendee link for this event from working. Attendees with the existing link will see an error."
    >
      {(confirm) => (
        <>
          <ErrorText color="error">{error}</ErrorText>
          <DangerButton
            variant="outlined"
            size="small"
            aria-label="disconnect obie"
            onClick={confirm}
          >
            Disconnect
          </DangerButton>
        </>
      )}
    </ConfirmDialog>
  )
}
